
const ipad = [
  {
    path: '/ipad',
    name: 'ipad',
    component: () => import('@/pages/common/views/ipad/ipadContent.vue'),
    children: [
      // 课堂评价
      {
        path: 'EvaStudentWrap',
        name: 'EvaStudentWrap',
        component: () => import( '@/pages/evaluation/views/ipad/classroomRecord/evaStudentWrap.vue')
      },
      {
        path: 'evaStatistics',
        name: 'evaStatistics',
        component: () => import( '@/pages/evaluation/views/ipad/classroomRecord/evaStatistics.vue')
      },
      {
        path: 'evaMyeva',
        name: 'evaMyeva',
        component: () => import( '@/pages/evaluation/views/ipad/classroomRecord/evaMyeva.vue')
      },
       // 课堂评价 -- 评价记录列表
       {
        path: 'EvaRecode',
        name: 'EvaRecodeList',
        component: () => import( '@/pages/evaluation/views/ipad/classroomRecord/recode.vue')
      },
        // 评价学生小组-学生-结果
      {
        path: 'evaStudent',
        name: 'evaStudent',
        component: () => import( '@/pages/evaluation/views/ipad/classroomRecord/evaStudent.vue')
      },
      // 德育一日评价
      // 班级德育指标
      {
        path: 'MoralEducation',
        name: 'MoralEducation',
        component: () => import( '@/pages/evaluation/views/ipad/moralEducation/MoralEducation.vue')
      },
      {
        path: 'MoralClassList',
        name: 'MoralClassList',
        component: () => import( '@/pages/evaluation/views/ipad/moralEducation/MoralClassList.vue')
      },
      // 学生德育指标
      {
        path: 'MoralStudentEducation',
        name: 'MoralStudentEducation',
        component: () => import( '@/pages/evaluation/views/ipad/moralEducation/MoralStudentEducation.vue')
      },
      // 我的德育评价
      {
        path: 'myEvaOfMoral',
        name: 'myEvaOfMoral',
        component: () => import( '@/pages/evaluation/views/ipad/moralEducation/myEvaOfMoral.vue')
      },
      
      // 学生德育-年级
      {
        path: 'MoralStudentsList',
        name: 'MoralStudentsList',
        component: () => import( '@/pages/evaluation/views/ipad/moralEducation/MoralStudentsList.vue')
      },
      //活动评价--我的活动评价
      {
        path: 'MyActivityEvaluation',
        name: 'MyActivityEvaluation',
        component: () => import( '@/pages/evaluation/views/ipad/activityEvaluation/MyActivityEvaluation.vue')
      },
      //活动评价--我的活动评价详情页面
      {
        path: 'MyActivityDetails',
        name: 'MyActivityDetails',
        component: () => import( '@/pages/evaluation/views/ipad/activityEvaluation/MyActivityDetails.vue')
      },
      //活动评价--活动评价
      {
        path: 'ActivityEvaluations',
        name: 'ActivityEvaluations',
        component: () => import( '@/pages/evaluation/views/ipad/activityEvaluation/ActivityEvaluations.vue')
      },
      //活动评价-- 指标列表
      {
        path: 'ActivityEvaluationDetails',
        name: 'ActivityEvaluationDetails',
        component: () => import( '@/pages/evaluation/views/ipad/activityEvaluation/ActivityEvaluationDetails.vue')
      },
      // 活动评价 -- 学生列表
      {
        path: 'ActivityEvaluationStuList',
        name: 'ActivityEvaluationStuList',
        component: () => import( '@/pages/evaluation/views/ipad/activityEvaluation/ActivityEvaluationStuList.vue')
      }
    ]
  }

]
export default ipad;
